function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

document.addEventListener("DOMContentLoaded", () => {
  const announcementBar = document.querySelector('[data-announcement-bar]');
  if (announcementBar) {
    const announcementBarSection = document.getElementById('shopify-section-announcement-bar');
    const announcementBarHeight = announcementBarSection.offsetHeight;
    const header = document.getElementById('shopify-section-header').querySelector('header');

    let scrollPosition = 0;
    header.classList.add('absolute');
    header.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');

    document.addEventListener("scroll", () => {
      scrollPosition = window.scrollY;
      if (scrollPosition < announcementBarHeight) {
        header.classList.add('absolute');
      } else {
        header.classList.remove('absolute');
      }
    });
  }

  const mediaSliders = document.querySelectorAll('.productThumb--single .productThumb__media--mobile > .swiper');
  if (mediaSliders && window.matchMedia("(max-width: 767px)").matches) {
    mediaSliders.forEach((mediaSlider) => {
      const swiperThumbMedia = new Swiper(mediaSlider, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    });
  }
});

if (!customElements.get('quick-add-to-cart')) {
  class QuickAddToCart extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[quick-atc-btn]');
      this.modal = this.querySelector('[quick-atc-modal]');
      this.variantButtons = this.querySelectorAll('.quick-add-to-cart__variant-add');

      this.button.addEventListener('click', () => {
        this.modal.classList.add('active');
      });

      const button = this.button;
      const modal = this.modal;
      window.addEventListener('click', function(e){
        if (!modal.contains(e.target) && !button.contains(e.target)){
          modal.classList.remove('active');
        }
      });

      this.variantButtons.forEach((variantButton) => {
        variantButton.addEventListener('click', () => {
          this.addVariantToCart(variantButton);
        });
      });
    }

    addVariantToCart(button) {
      const variantId = button.dataset.variantId;
      const preorderProperty = button.dataset.variantPreorder;

      let formData = {
        'items': [{
          'id': variantId,
          'properties': {
            'Preorder': preorderProperty ? 'Précommande' : ''
          },
          'quantity': 1
        }]
      };

      // add
      var request = new XMLHttpRequest();
      request.open('POST', '/cart/add.js', true);
      request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      request.onload = window.updateCart

      var dataTemp = JSON.stringify(formData);

      request.send(dataTemp);

      document.querySelector('.oCart').classList.add('on');
      document.querySelector('body').classList.add('cart-drawer-on');
    }
  }
  customElements.define('quick-add-to-cart', QuickAddToCart);
}